import clsx from 'clsx';
import { ComponentProps, FC, useEffect, useRef, useState } from 'react';
import { TextArea } from '../TextArea';
import styles from './AutoExpandTextArea.module.css';

interface AAutoExpandTextAreaProps
  extends Omit<ComponentProps<'textarea'>, 'ref'> {}

export const AutoExpandTextArea: FC<AAutoExpandTextAreaProps> = ({
  className,
  value,
  style,
  ...rest
}) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [height, setHeight] = useState(14);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight ? ref.current.scrollHeight + 2 : 14);
    }
  }, [value]);

  return (
    <TextArea
      ref={ref}
      style={{ height, ...style }}
      className={clsx(styles.textarea, className)}
      value={value}
      {...rest}
    />
  );
};
